<script lang="ts">

    import type { Video } from "../scripts/video";
    import { storeLanguage, lang_fr } from "../scripts/store";

    export let props: Video;
</script>

<style lang="scss">

	.tilevideo {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        width: 90%;
        margin: 100px 0 100px 0;
        &__title {
            align-self: flex-start;
            display: flex;
            flex-direction: column;
            justify-content: space-around;
            align-items: flex-start;
        }
        &__video {
            padding: 45px 15px 15px 15px;
            width: 100%;
        }
	}

    @include large {
        .tilevideo {
            width: 100%;
            display: grid;
            grid-template-columns: [grid-title] 30% [grid-video] 70%;
            &__video {
                cursor: pointer;
                padding: 0px 15px 0px 15px;
            }
        }
    }

</style>

<div class="tilevideo">
    <div class="tilevideo__title">
        {#if ($storeLanguage == $lang_fr)}
        <div class="font__h2">{props.title_fr}</div>
        <div class="font__h4">{props.subtitle_fr}</div>
        {:else}
        <div class="font__h2">{props.title_en}</div>
        <div class="font__h4">{props.subtitle_en}</div>
        {/if}
    </div>
    <video class="tilevideo__video" controls poster="../assets/images/videos/{props.id}_{props.poster}">
        <source src="../assets/images/videos/{props.id}_{props.file_video}" type="video/mp4">
        <track default kind="captions" srclang="fr" src="">
    </video>

</div>
